import videojs from 'video.js';
import esLang from 'video.js/dist/lang/es.json';
import hiLang from 'video.js/dist/lang/hi.json';
import zhLang from 'video.js/dist/lang/zh-CN.json';
import 'video.js/dist/video-js.css';
videojs.addLanguage('hi-HI', hiLang);
videojs.addLanguage('zh-CN', zhLang);
videojs.addLanguage('es-US', esLang);
export * from 'video.js';
export default videojs;